import { PREVIEW_ACCESS_TYPE_MESSAGE } from "@p0security/shared/integrations/constants";
import type { ComponentMaturity } from "@p0security/shared/integrations/shared";
import { Tag, Tooltip } from "@p0security/ui";

export const MaturityTag: React.FC<{
  maturity: Exclude<ComponentMaturity, "ga">;
}> = ({ maturity }) => (
  <Tooltip title={PREVIEW_ACCESS_TYPE_MESSAGE}>
    <Tag color="blue">{maturity}</Tag>
  </Tooltip>
);
